import { render } from "./EntitiesTrattative.vue?vue&type=template&id=41e41e90&scoped=true"
import script from "./EntitiesTrattative.vue?vue&type=script&lang=js"
export * from "./EntitiesTrattative.vue?vue&type=script&lang=js"

import "./EntitiesTrattative.vue?vue&type=style&index=0&id=41e41e90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e41e90"]])

export default __exports__